export default __webpack_public_path__ + "static/media/0xc6c855ad634dcdad23e64da71ba85b8c51e5ad7c.885b2e5b.webp";